// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Zlb9v","footerActions":"styles_footerActions__bN71r"};